import React from 'react'

import { t } from 'src/translations'

import { useCashRounding } from './useCashRounding'

export const CashRoundingDisclaimer = () => {
  const { showDisclaimer } = useCashRounding()

  if (!showDisclaimer) {
    return null
  }

  return (
    <div
      className='cashRoundingDisclaimer'
      data-testid='cash-rounding-disclaimer'
      role='complementary'
      aria-label={t('cash-rounding-disclaimer.full-disclaimer')}
    >
      {t('cash-rounding-disclaimer.full-disclaimer')}
    </div>
  )
}
